import { render, staticRenderFns } from "./ReporteVentaCompra.vue?vue&type=template&id=556ac22d&scoped=true&"
import script from "./ReporteVentaCompra.vue?vue&type=script&lang=js&"
export * from "./ReporteVentaCompra.vue?vue&type=script&lang=js&"
import style0 from "./ReporteVentaCompra.vue?vue&type=style&index=0&id=556ac22d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556ac22d",
  null
  
)

export default component.exports